const TRADE_UP_GROUP = "tradeupgroup";
const PERNAMBUCANAS = "pernambucanas";
const HPANDMCAFEE = "hpandmcafee"; // ! NÃO USA-SE
const HPMCAFEE = "hpmcafee";
const MCAFEE = "mcafee";
const RIGSTAR = "rigstar";
const CARREFOUR = "carrefour";
const MASTERCARD = "mastercard";
const SEMPRE_SEGURO = "sempresegurodigital";
const HP = "hp";

export default {
  TRADE_UP_GROUP,
  PERNAMBUCANAS,
  HPANDMCAFEE,
  HPMCAFEE,
  MCAFEE,
  RIGSTAR,
  CARREFOUR,
  MASTERCARD,
  SEMPRE_SEGURO,
  HP,
};
